import { StudentService } from 'data/services';
import { StudentServiceInterface } from 'domain/services';
import { makeRemoteGetAllStudents } from 'main/factories/usecases/persons/students/remote-get-all-students-factory';
import { makeRemoteGetAllStudentsNotPaginated } from 'main/factories/usecases/persons/students/remote-get-all-students-not-paginated-factory';
import { makeRemoteGetAllStudentsSelectOptions } from 'main/factories/usecases/persons/students/remote-get-all-students-select-options-factory';

export const makeStudentService = (): StudentServiceInterface =>
  new StudentService(
    makeRemoteGetAllStudents(),
    makeRemoteGetAllStudentsSelectOptions(),
    makeRemoteGetAllStudentsNotPaginated(),
  );
